import React, {useEffect} from 'react';
import {connect} from 'react-redux';

function SignIn({
}) {
  useEffect(() => {
  },[]);
  return (
    <React.Fragment>
        
    </React.Fragment>
  );
}

const mapStateToProps = (state) => {
  return {
  }
}

const mapDispatchToProps = dispatch => ({
});

export default connect(
)(SignIn)